"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = resolveLTR;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _arrayPrototype = _interopRequireDefault(require("array.prototype.flat"));
var _separateStyles2 = _interopRequireDefault(require("./separateStyles"));

// Styles is an array of properties returned by `create()`, a POJO, or an
// array thereof. POJOs are treated as inline styles. This version of the
// resolve function explicitly does no work to flip styles for an RTL context.
// This function returns an object to be spread onto an element.
function resolveLTR(css, styles) {
  var flattenedStyles = (0, _arrayPrototype["default"])(styles, Infinity);
  var _separateStyles = (0, _separateStyles2["default"])(flattenedStyles),
    aphroditeStyles = _separateStyles.aphroditeStyles,
    hasInlineStyles = _separateStyles.hasInlineStyles,
    inlineStyles = _separateStyles.inlineStyles;
  var result = {};
  if (aphroditeStyles.length > 0) {
    result.className = css.apply(void 0, (0, _toConsumableArray2["default"])(aphroditeStyles));
  }
  if (hasInlineStyles) {
    result.style = inlineStyles;
  }
  return result;
}